// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dE-z","hovered":"eE-z","hoverImage":"fE-z","mainImage":"gE-z","imageNoBackground":"hE-z","fullSizeImage":"iE-z"};